import { render, staticRenderFns } from "./PersonSign.vue?vue&type=template&id=5377cb20&scoped=true"
import script from "./PersonSign.vue?vue&type=script&lang=js"
export * from "./PersonSign.vue?vue&type=script&lang=js"
import style0 from "./PersonSign.vue?vue&type=style&index=0&id=5377cb20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5377cb20",
  null
  
)

export default component.exports